import OrganizerProfile from '../../organizer-profile';

import constants from './constants';
import { REQUEST_STATUS } from '../constants';
import glossary, { REQUEST_STATUS_DATA } from './glossary';
import EventAssociation from '..';

export default class AssociationAccreditationOrganizer extends OrganizerProfile {
  constructor(item = {}, url = '') {
    super(item, url);

    this.accreditation_status = item.accreditation_status || REQUEST_STATUS.new;

    this.event_association_accreditations = [...item.event_association_accreditations || []].map((i) => new EventAssociation(i));
  }

  get statusData() {
    const { accreditation_status } = this;
    const data = REQUEST_STATUS_DATA[accreditation_status];
    return {
      ...data,
      isNew: accreditation_status === REQUEST_STATUS.new,
      isAccepted: accreditation_status === REQUEST_STATUS.accepted,
      isRejected: accreditation_status === REQUEST_STATUS.rejected,
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
